import axios from "axios"
import { DateTime } from "luxon"

import { notificationsUrl as api_url } from "../../config/microservicesUrls"

async function axiosPut(jwt, endpoint, data) {
  const axiosObj = axios.create()

  const requestConfig = {
    headers: {
      Authorization: "Bearer " + jwt,
      "Content-Type": "application/json",
    },
  }

  const url = api_url()
  //console.log(url)
  const result = await axiosObj
    .put(`${url}/${endpoint}`, data, requestConfig)
    .then((responseBody) => {
      return responseBody.data
    })

  return result
}

async function axiosPost(jwt, endpoint, data) {
  const axiosObj = axios.create()

  const requestConfig = {
    headers: {
      Authorization: "Bearer " + jwt,
      "Content-Type": "application/json",
    },
  }

  const url = api_url()
  const x = await axiosObj
    .post(`${url}/${endpoint}`, data, requestConfig)
    .then((responseBody) => {
      return responseBody.data
    })

  return x
}

async function axiosGet(jwt, endpoint) {
  const axiosObj = axios.create()

  const requestConfig = {
    headers: {
      Authorization: "Bearer " + jwt,
    },
  }

  const url = api_url()
  const x = await axiosObj
    .get(`${url}/${endpoint}`, requestConfig)
    .then((responseBody) => {
      return responseBody.data
    })

  return x
}

export async function noteApiMarkAllAsReadPut(jwt, user) {
  return await axiosPut(jwt, "Notification/MarkAllRead", {
    groupId: "All",
    userId: user.participant_id,
    alternateUserId: user.participant_alias,
  })
}

export async function noteApiMarkAllSystemAsReadPut(jwt, user) {
  // Collect all organization IDs and aliases the user belongs to
  const ids = user.participant_organizations?.map(org => org.organization_id) || [];
  const aliases = user.participant_organizations?.map(org => org.organization_alias) || [];
  const groupIds = [...ids, ...aliases];

  return await axiosPut(jwt, "Notification/MarkAllRead/System", {
    groupId: "All",
    groupIds: groupIds,
    userId: user.participant_id,
    alternateUserId: user.participant_alias || "0",
  });
}

export async function noteApiMarkAsReadPut(jwt, notificationGuid) {
  return await axiosPut(jwt, "Notification/MarkRead", notificationGuid)
}

export async function noteApiMarkSystemAsReadPut(
  jwt,
  notificationGuid,
  userId
) {
  return await axiosPut(jwt, "Notification/MarkRead/System", {
    notificationId: notificationGuid,
    userId: userId,
  })
}

export async function noteApiMarkAsUnreadPut(jwt, notificationGuid) {
  return await axiosPut(jwt, "Notification/MarkUnread", notificationGuid)
}

export async function noteApiMarkSystemAsUnreadPut(
  jwt,
  notificationGuid,
  userId
) {
  return await axiosPut(jwt, "Notification/MarkUnread/System", {
    notificationId: notificationGuid,
    userId: userId,
  })
}

export async function noteApiCountPost(
  jwt,
  enterpriseId,
  groupIds,
  uid,
  alias,
  creationDate
) {
  return await axiosPost(jwt, "Notification/Count", {
    enterpriseId: enterpriseId || "0",
    groupId: "All",
    groupIds: groupIds,
    userId: uid,
    alternateUserId: alias,
    peerId: "0",
    caseId: "0",
    systemNotificationFilters: ["Participants", "All"],
    CreateDateStartFilter: creationDate,
  })
}

export async function noteApiListMutedPost(jwt, organization_id, uid) {
  return await axiosPost(jwt, "Notification/Muted/List", {
    groupId: organization_id || "0",
    userId: uid,
  })
}

export async function noteApiMuteNotificationsPOST(
  jwt,
  organization_id,
  participant_id,
  eventTypes
) {
  return await axiosPost(jwt, "Notification/Mute", {
    groupId: organization_id,
    userId: participant_id,
    eventTypes: eventTypes,
  })
}

export async function noteApiListNotificationsPOST({
  jwt,
  userId,
  userAlias,
  organizationIds,
  readFilter,
  eventTypeFilter,
  createDateStartFilter,
  createDateEndFilter,
  readDateStartFilter,
  readDateEndFilter,
  titleFilter,
  sorting,
  pageNum,
  pageSize
}) {
  return await axiosPost(jwt, `Notification/List/Participant`, {
    groupId: "All",
    groupIds: organizationIds,
    alternateGroupId: "",
    userId: userId,
    alternateUserId: userAlias,
    readFilter: readFilter,
    eventTypeFilter: eventTypeFilter,
    createDateStartFilter: createDateStartFilter
      ? DateTime.fromJSDate(createDateStartFilter).startOf("day").toUTC()
      : null,
    createDateEndFilter: createDateEndFilter
      ? DateTime.fromJSDate(createDateEndFilter).endOf("day").toUTC()
      : null,
    readDateStartFilter: readDateStartFilter
      ? DateTime.fromJSDate(readDateStartFilter).startOf("day").toUTC()
      : null,
    readDateEndFilter: readDateEndFilter
      ? DateTime.fromJSDate(readDateEndFilter).endOf("day").toUTC()
      : null,
    systemNotificationFilters: ["Participants", "All"],
    titleFilter: titleFilter,
    sorting: sorting,
    pageNum: pageNum,
    pageSize: pageSize,
  })
}

export async function noteApiListEventTypesGet(jwt) {
  return await axiosGet(jwt, "Notification/List/EventTypes")
}

export async function noteApiUnmuteNotificationsGET(
  jwt,
  organization_id,
  user_id
) {
  return await axiosGet(
    jwt,
    `Notification/Unmute/${organization_id}/${user_id}`
  )
}
